import { StrictMode, Suspense, lazy } from 'react';
import { createRoot } from 'react-dom/client';

import PageLoading from './components/icons/PageLoading';
import { loadThemeSheets } from './theme';
import './styles/globals.css';

const app = import('./App');
const App = lazy(() => app);
const Devtools = import.meta.env.DEV ? lazy(() => import('./devtools/Devtools')) : null;

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

void loadThemeSheets().then(() => {
  createRoot(rootElement).render(
    <StrictMode>
      <Suspense fallback={<PageLoading />}>
        <App />
      </Suspense>
      {Devtools ? (
        <Suspense fallback={null}>
          <Devtools />
        </Suspense>
      ) : null}
    </StrictMode>,
  );
});
